export default __webpack_public_path__ + "static/media/shopify_transparent.7c042b87.png";